import { useEffect, useState } from 'react';
import { ReauthDialog } from '@loctopus/ui';
import { api, ApiRequestError } from '../lib/api';
import { setReauthToken } from '../lib/reauth';
import {
  cancelReauthPrompt,
  failReauthAttempt,
  resolveReauthPrompt,
  setReauthPending,
  subscribeReauthController,
  type ReauthControllerState,
} from '../lib/reauthController';

/**
 * Mounted once at the app root (see App.tsx). Purely a thin adapter between the shared
 * `ReauthDialog` UI (@loctopus/ui) and `lib/reauthController.ts`'s state machine - `lib/api.ts`'s
 * `request()` is what actually decides WHEN this needs to open, by calling `promptForReauth()`.
 */
export function GlobalReauthDialog() {
  const [state, setState] = useState<ReauthControllerState>({ open: false, pending: false });

  useEffect(() => subscribeReauthController(setState), []);

  async function handleSubmit(input: { password?: string; totpCode?: string }) {
    setReauthPending(true);
    try {
      const { reauthToken } = await api.auth.reauth(input);
      setReauthToken(reauthToken);
      resolveReauthPrompt();
    } catch (err) {
      failReauthAttempt(
        err instanceof ApiRequestError ? err.message : 'Could not re-authenticate. Try again.',
      );
    }
  }

  return (
    <ReauthDialog
      open={state.open}
      pending={state.pending}
      error={state.error}
      onCancel={cancelReauthPrompt}
      onSubmit={handleSubmit}
    />
  );
}
